//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { FeatureFlag } from "../FeatureFlag";

export const PaymentLocks: FeatureFlag = {"Id":"PaymentLocks","Label":"Lock submissions while out for payment","Impact":"Adds payment lock while out for payment. Commonly paired with FixateOnLock so locks keep calculations fixated until payment flow completes.","Mode":1,"ActiveOn":null,"ActiveUntil":null,"GlobalEnabled":false,"TenantEnabled":null,"UserEnabled":null,"Scope":7};
